const modalControllers = angular.module('modalControllers', []);

modalControllers.controller('notificationModalController', function(
  $scope,
  $uibModalInstance,
  $state,
  $filter,
  notificationItem,
  consist,
  listType,
  notificationService,
  toasterService,
  userService,
  userViewService,
  EventsService,
  __env
) {
  $scope.goToTrainPage = function() {
    let thisConsist = consist;
    if (notificationItem.train) thisConsist = notificationItem.train;
    if (notificationItem.consist) thisConsist = notificationItem.consist;
    $uibModalInstance.close(false);
    $state.go('train', { consist: thisConsist });
  };

  $scope.goToCarPage = function() {
    let thisConsist = consist;
    if (notificationItem.train) thisConsist = notificationItem.train;
    if (notificationItem.consist) thisConsist = notificationItem.consist;
    $uibModalInstance.close(false);
    $state.go('car', { carNumber: notificationItem.carNumber, trainId: thisConsist });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.openEventDeleteConfifmation = function() {
    $scope.isShowingDeleteConfirmation = true;
    $scope.confirmDeleteEvent = function () {
      const params = { id: notificationItem.id }
      if ($scope.listType === 'active') {
        EventsService.deleteActiveEvent(params).then(
          response => {
            handleEventDeletionResponse(response, notificationItem.id);
          })
      } else if ($scope.listType === 'history')
        EventsService.deleteHistoryEvent(params).then(
          response => {
            handleEventDeletionResponse(response, notificationItem.id);
          })
    }
    $scope.cancelDeleteEvent = function () {
      $scope.isShowingDeleteConfirmation = false;
    }
  };

  const handleEventDeletionResponse = (response, id) => {
    if (response.statusCode === 204 || response.statusCode === 200) {
      toasterService.success('', 'Event deleted successfully!');
      $uibModalInstance.close(id);
    } else {
      if (response.statusCode === 404) {
        toasterService.error('', 'Event deletion failed. Event was not found from database.'); 
      } else if (response.statusCode === 504) {
        toasterService.error('', 'Event deletion failed due to no connection to Smatrtvision backend'); 
      } else {
        toasterService.error('', 'Event deletion failed. Error code : ' + response.statusCode);
      }
    }
  } 

  $scope.isAlert = function() {
    return $scope.notificationItem.level === 2;
  };

  $scope.acknowledge = function(notification) {
    notificationService.acknowledge(notification).then(
      function() {
        toasterService.success('toaster.acknowledge-event', 'toaster.acknowledge-event-successful');
        $uibModalInstance.close(true);
      },
      function() {}
    );
  };

  const operatorAcknowledgedDateHandler = function() {
    if ($scope.isTrainOperatorAck) {
      const acknowledgedDate = $scope.notificationItem.acknowledged;
      if (acknowledgedDate === null) {
        $scope.acknowledgedDisplay = '-';
        return;
      }
      const formatted = $filter('formatTimestamp')(acknowledgedDate);
      $scope.acknowledgedDisplay = formatted || '-';
    } else {
      const ackValue = $scope.notificationItem.ack;
      $scope.acknowledgedDisplay = ackValue !== null ? ackValue : '-';
    }
  };

  function init() {
    $scope.notificationItem = notificationItem;
    $scope.consist = consist;
    $scope.listType = listType;
    $scope.isTrainOperatorAck = __env.profile === 'LU';
    $scope.hasConsist = __env.profile !== 'QR' && __env.profile !== 'VALE' && __env.profile !== 'MELCO';
    $scope.customDialog = __env.profile === 'MELCO';
    $scope.hasCarPage = __env.profile === 'VALE' || __env.profile === 'DEMO';
    $scope.isTrainsPage = userViewService.getView() === 'trains';
    $scope.isCarPage = userViewService.getView() === 'carView';
    $scope.isShowingDeleteConfirmation = false;
    $scope.hasDeleteEvents = userService.hasDeleteEvents();
    operatorAcknowledgedDateHandler();
  }
  init();
});

modalControllers.controller('forgotPasswordModalController', function($scope, $uibModalInstance, userService) {
  $scope.email = '';

  $scope.send = function() {
    userService.forgotPassword($scope.email).then(function() {
      $uibModalInstance.close();
    });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
});

modalControllers.controller('resetWidgetsModalController', function($scope, $uibModalInstance) {
  $scope.save = function() {
    $uibModalInstance.close();
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
});

modalControllers.controller('deleteDescriptorModalController', function($scope, $uibModalInstance, descriptorItem) {
  $scope.descriptorItem = descriptorItem;

  if ($scope.descriptorItem.type === 'HW_REVISION') {
    $scope.descriptorType = 'Hardware revision';
  } else if ($scope.descriptorItem.type === 'SW_REVISION') {
    $scope.descriptorType = 'Software revision';
  } else if ($scope.descriptorItem.type === 'PARAM_REVISION') {
    $scope.descriptorType = 'Parameter revision';
  } else {
    $scope.descriptorType = 'Unknown revision type';
  }

  $scope.save = function() {
    $uibModalInstance.close();
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
});

modalControllers.controller('carModalController', function(
  $scope,
  $uibModalInstance,
  chartColorService,
  carObject
) {
  $scope.carObject = angular.copy(carObject);
  $scope.chartVisible = false;
  $scope.gridVisible = true;

  $scope.createSubsystemObject = name => {
    $scope.initData();
    $scope.subSystemObject = $scope.handleSubsystemType(name, $scope.carObject.number);
    $scope.gridVisible = false;
  };

  $scope.showGrid = () => {
    $scope.gridVisible = true;
  };

  $scope.initData = () => {
    $scope.propulsionCIS = [
      {
        name: 'Traction motor 1 temperature',
        value: $scope.currentData.propulsionMotor1Temp,
        unit: '°C',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionMotor1Temp'),
        config: {
          warningThreshold: 140,
          alarmThreshold: 160,
          minRange: 150,
        },
      },
      {
        name: 'Traction motor 1 Vibration, RMS',
        value: $scope.currentData.propulsionMotor1VibrationRms,
        unit: 'm/s2',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionMotor1VibrationRms'),
        config: { warningThreshold: 9, alarmThreshold: 12, minRange: 12 },
      },
      {
        name: 'Traction motor 1 Vibration, Kurtosis',
        value: $scope.currentData.propulsionMotor1VibrationKurtosis,
        unit: '',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionMotor1VibrationKurtosis'),
        config: { warningThreshold: 5, alarmThreshold: 7, minRange: 7 },
      },
      {
        name: 'Traction motor 1 Vibration, Crest',
        value: $scope.currentData.propulsionMotor1VibrationCrest,
        unit: 'dB',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionMotor1VibrationCrest'),
        config: { warningThreshold: 7, alarmThreshold: 9, minRange: 9 },
      },
      {
        name: 'Traction motor 2 temperature',
        value: $scope.currentData.propulsionMotor2Temp,
        unit: '°C',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionMotor2Temp'),
        config: {
          warningThreshold: 140,
          alarmThreshold: 160,
          minRange: 150,
        },
      },
      {
        name: 'Traction motor 2 Vibration, RMS',
        value: $scope.currentData.propulsionMotor2VibrationRms,
        unit: 'm/s2',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionMotor2VibrationRms'),
        config: { warningThreshold: 9, alarmThreshold: 12, minRange: 12 },
      },
      {
        name: 'Traction motor 2 Vibration, Kurtosis',
        value: $scope.currentData.propulsionMotor2VibrationKurtosis,
        unit: '',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionMotor2VibrationKurtosis'),
        config: { warningThreshold: 5, alarmThreshold: 7, minRange: 7 },
      },
      {
        name: 'Traction motor 2 Vibration, Crest',
        value: $scope.currentData.propulsionMotor2VibrationCrest,
        unit: 'dB',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionMotor2VibrationCrest'),
        config: { warningThreshold: 7, alarmThreshold: 9, minRange: 9 },
      },
      {
        name: 'Gearbox 1 Temperature',
        value: $scope.currentData.propulsionGearbox1Temp,
        unit: '°C',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionGearbox1Temp'),
        config: { warningThreshold: 65, alarmThreshold: 80, minRange: 80 },
      },
      {
        name: 'Gearbox 1 Vibration, RMS',
        value: $scope.currentData.propulsionGearbox1Vibration,
        unit: 'm/s2',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionGearbox1Vibration'),
        config: { warningThreshold: 11, alarmThreshold: 13, minRange: 13 },
      },
      {
        name: 'Gearbox 2 Temperature',
        value: $scope.currentData.propulsionGearbox2Temp,
        unit: '°C',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionGearbox2Temp'),
        config: { warningThreshold: 65, alarmThreshold: 80, minRange: 80 },
      },
      {
        name: 'Gearbox 2 Vibration, RMS',
        value: $scope.currentData.propulsionGearbox2Vibration,
        unit: 'm/s2',
        status: 'Normal',
        data: $scope._processParsedData($scope.historyData, 'propulsionGearbox2Vibration'),
        config: { warningThreshold: 11, alarmThreshold: 13, minRange: 13 },
      },
    ];
    $scope.checkSubsystemStatus();
  };

  $scope._processParsedData = (data, key) => {
    return data.map(item => {
      return [item.timestamp, item[key]];
    });
  };

  $scope.handleSubsystemType = (name, carNumber) => {
    if (name === 'hvac') {
      return {
        name: 'HVAC',
        cis: $scope.hvacCIS,
        carNumber: carNumber,
      };
    } else if (name === 'brakes') {
      return {
        name: 'Brakes',
        cis: $scope.brakesCIS,
        carNumber: carNumber,
      };
    } else if (name === 'doors') {
      return {
        name: 'Doors',
        cis: $scope.doorsCIS,
        carNumber: carNumber,
      };
    } else if (name === 'saloon') {
      return {
        name: 'Saloon comfort',
        cis: $scope.saloonCIS,
        carNumber: carNumber,
      };
    } else if (name === 'propulsion') {
      return {
        name: 'Propulsion',
        cis: $scope.propulsionCIS,
        carNumber: carNumber,
      };
    } else if (name === 'wheelsets') {
      return {
        name: 'Wheelsets',
        cis: $scope.wheelCIS,
        carNumber: carNumber,
      };
    } else if (name === 'aux') {
      return {
        name: 'Auxiliary power',
        cis: $scope.auxCIS,
        carNumber: carNumber,
      };
    }
  };

  $scope.checkSubsystemStatus = () => {
    const checkCiStatus = ciList => {
      for (const ci of ciList) {
        if (ci.value > ci.config.alarmThreshold) {
          ci.status = 'Alert level reached';
        } else if (ci.value > ci.config.warningThreshold) {
          ci.status = 'Warning level reached';
        }
      }
    };
    checkCiStatus($scope.hvacCIS);
    checkCiStatus($scope.wheelCIS);
    checkCiStatus($scope.brakesCIS);
    checkCiStatus($scope.doorsCIS);
    checkCiStatus($scope.saloonCIS);
    checkCiStatus($scope.propulsionCIS);
    for (let i = 0; i < $scope.auxCIS.length; ++i) {
      if (i === 0 || i === 2 || i === 3) {
        if ($scope.auxCIS[i].value > $scope.auxCIS[i].config.alarmThreshold) {
          $scope.auxCIS[i].status = 'Alert level reached';
        } else if ($scope.auxCIS[i].value > $scope.auxCIS[i].config.warningThreshold) {
          $scope.auxCIS[i].status = 'Warning level reached';
        }
      } else {
        if ($scope.auxCIS[i].value < $scope.auxCIS[i].config.alarmThreshold) {
          $scope.auxCIS[i].status = 'Alert level reached';
        } else if ($scope.auxCIS[i].value < $scope.auxCIS[i].config.warningThreshold) {
          $scope.auxCIS[i].status = 'Warning level reached';
        }
      }
    }
  };

  $scope.config = {};

  $scope.openGraph = (subsystem, data, config) => {
    $scope.chartVisible = true;
    $scope.activeCI = subsystem;
    $scope.splineConfigDefaults(config);
    $scope.loadEventsWithDate(data);
  };

  $scope.formatTime = timeMillis => {
    return DateTime.fromISO(timeMillis)
      .setLocale('fi')
      .toFormat('D');
  };

  $scope.splineConfigDefaults = config => {
    $scope.config = {
      chart: {
        type: 'spline',
        marginRight: 120,
        zoomType: 'x',
      },
      exporting: {
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      xAxis: {
        type: 'datetime',
        gridLineWidth: 1,
        crosshair: {
          snap: true,
        },
        // labels: {
        //   formatter: function() {
        //     // This can change based on time span.
        //     return $scope.formatTime(this.value);
        //   },
        // },
      },
      yAxis: {
        min: 0,
        minRange: config.minRange,
        allowDecimals: false,
        plotLines: [
          {
            color: '#4B92DB', // Color value
            dashStyle: 'dot', // Style of the plot line. Default to solid
            value: config.warningThreshold, // Value of where the line will appear
            width: 2, // Width of the line
            label: {
              text: 'Warning level', // Content of the label.
              align: 'right', // Positioning of the label.
              x: +65, // Amount of pixels the label will be repositioned according to the alignment.
              y: +4,
            },
          },
          {
            color: '#4B92DB', // Color value
            dashStyle: 'dot', // Style of the plot line. Default to solid
            value: config.alarmThreshold, // Value of where the line will appear
            width: 2, // Width of the line
            label: {
              text: 'Alert level', // Content of the label.
              align: 'right', // Positioning of the label.
              x: +65, // Amount of pixels the label will be repositioned according to the alignment.
              y: +4,
            },
          },
        ],
      },
      legend: {},
      tooltip: {
        formatter: function() {
          const dateStr = DateTime.fromISO(this.x)
            .setLocale('fi')
            .toFormat('DDDD t');
          return (
            '<span style="font-size: 11px">' +
            dateStr +
            '</span><br/>' +
            '<span>' +
            $scope.activeCI +
            '</span><br/>' +
            '<span style="color:' +
            this.color +
            '">\u25CF</span> ' +
            'Measurement value' +
            ': <b>' +
            this.y +
            '</b>'
          );
        },
        shared: false,
      },
      series: [],
    };
    $scope.$broadcast('reload');
  };

  $scope.loadEventsWithDate = function(data) {
    $scope.config.series = [
      {
        id: 1,
        count: 1,
        name: null,
        type: null,
        data: data,
      },
    ];

    chartColorService.fillDataWithColors($scope.config.series);
  };

  $scope.closeGraph = () => {
    $scope.chartVisible = false;
  };

  $scope.save = function() {
    $uibModalInstance.close();
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
});

modalControllers.controller('subSystemModalController', function(
  $scope,
  $uibModalInstance,
  chartColorService,
  subSystemObject
) {
  $scope.subSystemObject = angular.copy(subSystemObject);

  $scope.config = {};

  $scope.openGraph = (subsystem, data, config) => {
    $scope.chartVisible = true;
    $scope.activeCI = subsystem;
    $scope.splineConfigDefaults(config);
    $scope.loadEventsWithDate(data);
  };

  $scope.formatTime = timeMillis => {
    return DateTime.fromISO(timeMillis)
      .setLocale('fi')
      .toFormat('D');
  };

  $scope.splineConfigDefaults = config => {
    $scope.config = {
      chart: {
        type: 'spline',
        marginRight: 100,
        zoomType: 'x',
      },
      exporting: {
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      xAxis: {
        type: 'datetime',
        gridLineWidth: 1,
        crosshair: {
          snap: true,
        },
        // labels: {
        //   formatter: function() {
        //     // This can change based on time span.
        //     return $scope.formatTime(this.value);
        //   },
        // },
      },
      yAxis: {
        min: 0,
        minRange: config.minRange,
        allowDecimals: false,
        plotLines: [
          {
            color: '#4B92DB', // Color value
            dashStyle: 'dot', // Style of the plot line. Default to solid
            value: config.warningThreshold, // Value of where the line will appear
            width: 2, // Width of the line
            label: {
              text: 'Warning Level', // Content of the label.
              align: 'right', // Positioning of the label.
              x: +65, // Amount of pixels the label will be repositioned according to the alignment.
              y: +4,
            },
          },
          {
            color: '#4B92DB', // Color value
            dashStyle: 'dot', // Style of the plot line. Default to solid
            value: config.alarmThreshold, // Value of where the line will appear
            width: 2, // Width of the line
            label: {
              text: 'Alert Level', // Content of the label.
              align: 'right', // Positioning of the label.
              x: +65, // Amount of pixels the label will be repositioned according to the alignment.
              y: +4,
            },
          },
        ],
      },
      legend: {},
      tooltip: {
        formatter: function() {
          const dateStr = DateTime.fromISO(this.x)
            .setLocale('fi')
            .toFormat('DDDD t');
          return (
            '<span style="font-size: 11px">' +
            dateStr +
            '</span><br/>' +
            '<span>' +
            $scope.activeCI +
            '</span><br/>' +
            '<span style="color:' +
            this.color +
            '">\u25CF</span> ' +
            'Measurement value' +
            ': <b>' +
            this.y +
            '</b>'
          );
        },
        shared: false,
      },
      series: [],
    };
    $scope.$broadcast('reload');
  };

  $scope.loadEventsWithDate = function(data) {
    $scope.config.series = [
      {
        id: 1,
        count: 1,
        name: null,
        type: null,
        data: data,
      },
    ];

    chartColorService.fillDataWithColors($scope.config.series);
  };

  $scope.closeGraph = () => {
    $scope.chartVisible = false;
  };

  $scope.save = function() {
    $uibModalInstance.close();
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };
});

modalControllers.controller('singleGraphModalController', function(
  $scope,
  $uibModalInstance,
  chartColorService,
  subSystemObject
) {
  $scope.subSystemObject = angular.copy(subSystemObject);

  $scope.config = {};

  $scope.formatTime = timeMillis => {
    return DateTime.fromISO(timeMillis)
      .setLocale('fi')
      .toFormat('D');
  };

  $scope.splineConfigDefaults = config => {
    $scope.config = {
      chart: {
        type: 'spline',
        marginRight: 100,
        zoomType: 'x',
      },
      exporting: {
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      xAxis: {
        type: 'datetime',
        gridLineWidth: 1,
        crosshair: {
          snap: true,
        },
        // labels: {
        //   formatter: function() {
        //     // This can change based on time span.
        //     return $scope.formatTime(this.value);
        //   },
        // },
      },
      yAxis: {
        min: 0,
        minRange: config.minRange,
        allowDecimals: false,
        plotLines: [
          {
            color: '#4B92DB', // Color value
            dashStyle: 'dot', // Style of the plot line. Default to solid
            value: config.warningThreshold, // Value of where the line will appear
            width: 2, // Width of the line
            label: {
              text: 'Warning Level', // Content of the label.
              align: 'right', // Positioning of the label.
              x: +65, // Amount of pixels the label will be repositioned according to the alignment.
              y: +4,
            },
          },
          {
            color: '#4B92DB', // Color value
            dashStyle: 'dot', // Style of the plot line. Default to solid
            value: config.alarmThreshold, // Value of where the line will appear
            width: 2, // Width of the line
            label: {
              text: 'Alert Level', // Content of the label.
              align: 'right', // Positioning of the label.
              x: +65, // Amount of pixels the label will be repositioned according to the alignment.
              y: +4,
            },
          },
        ],
      },
      legend: {},
      tooltip: {
        formatter: function() {
          const dateStr = DateTime.fromISO(this.x)
            .setLocale('fi')
            .toFormat('DDDD t');
          return (
            '<span style="font-size: 11px">' +
            dateStr +
            '</span><br/>' +
            '<span>' +
            $scope.activeCI +
            '</span><br/>' +
            '<span style="color:' +
            this.color +
            '">\u25CF</span> ' +
            'Measurement value' +
            ': <b>' +
            this.y +
            '</b>'
          );
        },
        shared: false,
      },
      series: [],
    };
    $scope.$broadcast('reload');
  };

  $scope.loadEventsWithDate = function(data) {
    $scope.config.series = [
      {
        id: 1,
        count: 1,
        name: null,
        type: null,
        data: data,
      },
    ];

    chartColorService.fillDataWithColors($scope.config.series);
  };

  $scope.closeGraph = () => {
    $scope.chartVisible = false;
  };

  $scope.save = function() {
    $uibModalInstance.close();
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };

  function init() {
    $scope.activeCI = subSystemObject.cis.name;
    $scope.splineConfigDefaults(subSystemObject.cis.config);
    $scope.loadEventsWithDate(subSystemObject.cis.data);
  }

  init();
});
